import React, { memo } from "react";

import PropTypes from "prop-types";

import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import ClickableRow from "../ClickableRow";
import {
  AssignMenuItemListReset,
  AssignSplitMenuCss,
} from "./AssignSplitMenu.style.js";

export const propTypes = {
  contentId: PropTypes.string,
  contentWithAdvisory: PropTypes.bool,
  openModal: PropTypes.func,
  addToAssignmentButtonRef: PropTypes.func, // PropTypes.ref is not part of PropTypes https://stackoverflow.com/a/51127130
  createAssignmentButtonRef: PropTypes.func, // PropTypes.ref is not part of PropTypes https://stackoverflow.com/a/51127130
  createAssignmentUrl: PropTypes.href,
  streamProperties: PropTypes.object,
};

const AssignSplitMenu = ({
  contentId,
  openModal,
  addToAssignmentButtonRef,
  createAssignmentButtonRef,
  createAssignmentUrl,
  contentWithAdvisory = false,
  streamProperties,
}) => {
  const { data: user } = useUser();
  const { isTeacher, isParent } = getUserProperties(user);

  const options = [
    {
      label: "Create Assignment",
      qaSelector: "create_assignment",
      href: createAssignmentUrl,
      ref: createAssignmentButtonRef,
    },
    {
      label: "Add to Assignment",
      onClick: openModal,
      qaSelector: "add_to_assignment",
      ref: addToAssignmentButtonRef,
    },
  ];

  if (!(isTeacher || isParent) || !contentId || !createAssignmentUrl) {
    return null;
  }

  const qaSelectorPrefix = contentWithAdvisory
    ? "cat_split_menu_"
    : "split_menu_";
  return (
    <ul css={AssignSplitMenuCss}>
      {options.map((item) => {
        return (
          <li key={item.label} css={AssignMenuItemListReset}>
            <ClickableRow
              onClick={item?.onClick}
              href={item?.href}
              label={item.label}
              ref={item?.ref}
              dataProps={{
                "data-qa-selector": `${qaSelectorPrefix}${item.qaSelector}`,
              }}
              trackImpression={false}
              streamProperties={streamProperties}
            >
              {item.label}
            </ClickableRow>
          </li>
        );
      })}
    </ul>
  );
};

AssignSplitMenu.propTypes = propTypes;
export default memo(AssignSplitMenu);
